import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { brandName, outcomes } from '../data/copy';
export function FinalCtaSection() {
  const negatives = outcomes.filter(outcome => !outcome.positive);
  const positives = outcomes.filter(outcome => outcome.positive);
  return <section className="defer-paint w-full bg-zinc-900 py-12 sm:py-16" aria-labelledby="final-cta-heading" data-id="element-60" data-mp="3vrkxpiy7qddw">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-61" data-mp="2y66oyezbxq4w">
        <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-yellow-500" data-id="element-62" data-mp="333p08c0tkhg2">La prossima settimana</p>
        <h2 id="final-cta-heading" className="mx-auto mt-5 max-w-3xl font-serif text-[2rem] font-bold leading-[1.08] text-stone-100 sm:text-[2.6rem]" data-id="element-63" data-mp="3820b8q2uoxzv">
          Puoi continuare a improvvisare sessioni la domenica… o arrivare in
          pista <span className="text-yellow-500" data-id="element-64" data-mp="2fc9xwj91m04t">con il tuo sistema pronto</span>.
        </h2>

        <div className="mx-auto mt-10 grid max-w-3xl gap-4 text-left sm:grid-cols-2" data-id="element-65" data-mp="2kbmjz1s3b36c">
          <div className="rounded-3xl border border-zinc-800 bg-zinc-950 p-6" data-id="element-66" data-mp="2dbgvdfa1esoh">
            <h3 className="font-serif text-lg font-bold text-stone-100" data-id="element-67" data-mp="28dyijdswftb7">
              Continua a improvvisare
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-68" data-mp="23kduoel0sfpq">
              {negatives.map(outcome => <li key={outcome.text} className="flex items-start gap-2.5 font-sans text-[0.88rem] leading-relaxed text-stone-400" data-id="element-69" data-mp="1ym2lm62ju98k">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" strokeWidth={2.6} aria-hidden="true" data-id="element-70" data-mp="1umtocr8avt89" />
                  {outcome.text}
                </li>)}
            </ul>
          </div>
          <div className="rounded-3xl border border-yellow-500/40 bg-yellow-500/[0.07] p-6" data-id="element-71" data-mp="1knl08f0498tt">
            <h3 className="font-serif text-lg font-bold text-yellow-500" data-id="element-72" data-mp="1fq2pqk6galjp">
              Prendi {brandName}
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-73" data-mp="3eyzr4z4v5eb5">
              {positives.map(outcome => <li key={outcome.text} className="flex items-start gap-2.5 font-sans text-[0.88rem] font-semibold leading-relaxed text-stone-100" data-id="element-74" data-mp="3a2smras48avb">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-yellow-500" strokeWidth={2.6} aria-hidden="true" data-id="element-75" data-mp="1d3jx7ghkpmh4" />
                  {outcome.text}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-9 max-w-prose font-sans text-base leading-relaxed text-stone-400" data-id="element-76" data-mp="13d8svstz9b9p">
          Non hai bisogno di essere l'allenatore perfetto. Hai solo bisogno di
          un sistema che ti aiuti a pianificare velocemente, allenare con
          struttura e sviluppare atleti con coerenza.
        </p>

        <CtaButton size="large" className="mt-8" data-id="element-77" data-mp="1i24ylj8kac75">
          Ottieni {brandName} ora
        </CtaButton>
        <p className="mt-4 font-sans text-[11px] text-stone-400" data-id="element-78" data-mp="1m2x4c2i85yyo">
          Pagamento sicuro · accesso immediato · garanzia di 7 giorni
        </p>
      </div>
    </section>;
}